import React from 'react';
import { Card, CardContent } from '@mui/material';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import ChartHeader from './ChartHeader';
import { ChartHeaderProps } from './types';
import ChartCardWrapper from './ChartCardWrapper';
import { fontSizes } from '../../theme/theme';

interface HistogramData {
  [key: string]: string | number;
}

interface HistogramProps extends ChartHeaderProps {
  data: HistogramData[];
  dataKey: string;
  xAxisKey: string;
  color?: string;
  height?: number;
  graphHeight?: number;
  xAxisTitle?: string;
  yAxisTitle?: string;
  barGap?: number;
  barCategoryGap?: string;
  onDetailsClick?: (data?: any) => void;
}

const Histogram: React.FC<HistogramProps> = ({
  title,
  description,
  data,
  dataKey,
  xAxisKey,
  color = '#3B82F6',
  height = 300,
  graphHeight = 300,
  xAxisTitle,
  yAxisTitle,
  barGap = 0,
  barCategoryGap = '5%',
  details,
  onDetailsClick
}) => {
  const handleBarClick = (data: any) => {
    if (onDetailsClick) {
      onDetailsClick(data);
    }
    console.log('Clicked Histogram Bar:');
    console.log('Category:', data[xAxisKey]);
    console.log('Value:', data[dataKey]);
    console.log('Full Data:', data);
  };

  return (
    <ChartCardWrapper sx={{ height }}>
      <ChartHeader title={title} description={description} details={details} />
      <ResponsiveContainer width="100%" height={graphHeight}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
          barGap={barGap}
          barCategoryGap={barCategoryGap}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" vertical={false} />
          <XAxis
            dataKey={xAxisKey}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: fontSizes.graph.axis, fill: '#6B7280' }}
            label={xAxisTitle ? { value: xAxisTitle, position: 'insideBottom', offset: -2, style: { textAnchor: 'middle', fontSize: fontSizes.graph.axis, fill: '#374151' } } : undefined}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: fontSizes.graph.axis, fill: '#6B7280' }}
            label={yAxisTitle ? { value: yAxisTitle, angle: -90, position: 'insideLeft', style: { textAnchor: 'middle', fontSize: fontSizes.graph.axis, fill: '#374151' } } : undefined}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#F9FAFB',
              border: '1px solid #E5E7EB',
              borderRadius: '8px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              fontSize: `${fontSizes.graph.tooltip}px`
            }}
            cursor={{ fill: 'rgba(59, 130, 246, 0.1)' }}
          />
          <Bar
            dataKey={dataKey}
            fill={color}
            radius={[4, 4, 0, 0]}
            onClick={handleBarClick}
            cursor="pointer"
          />
        </BarChart>
      </ResponsiveContainer>
    </ChartCardWrapper>
  );
};

export default Histogram;
